(function () {
  'use strict';

  function rootUrl() {
    var root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
    return String(root||'/').replace(/\/?$/,'/');
  }
  function isDesignMode(){return Boolean(window.Shopify&&window.Shopify.designMode);}
  function setLoading(control,on){
    if(!control)return;
    control.classList.toggle('is-loading',Boolean(on));
    control.setAttribute('aria-busy',on?'true':'false');
  }
  function openDestination(url,control){
    setLoading(control,true);
    if(isDesignMode()){
      var popup=window.open(url,'_blank');
      if(!popup){
        var link=document.createElement('a');
        link.href=url;link.target='_blank';link.rel='noopener';link.style.display='none';
        document.body.appendChild(link);link.click();link.remove();
      }
      window.setTimeout(function(){setLoading(control,false);},900);
      return;
    }
    window.location.assign(url);
  }
  function checkoutUrl(){return new URL(rootUrl()+'checkout',window.location.origin).toString();}
  function selectedVariantId(productRoot){
    if(!productRoot)return'';
    var checked=productRoot.querySelector('.veyrissa-variant-radio:checked');
    if(checked&&!checked.disabled&&checked.value)return checked.value;
    var select=productRoot.querySelector('[data-variant-select]');
    if(select&&select.value)return select.value;
    var hidden=productRoot.querySelector('[data-product-form] input[name="id"][type="hidden"]');
    if(hidden&&hidden.value)return hidden.value;
    return productRoot.getAttribute('data-current-variant-id')||'';
  }
  function selectedQuantity(productRoot){
    var input=productRoot&&productRoot.querySelector('[data-product-form] [name="quantity"]');
    var quantity=input?parseInt(input.value,10):1;
    return Number.isFinite(quantity)&&quantity>0?quantity:1;
  }
  function directBuyUrl(productRoot){
    var variantId=selectedVariantId(productRoot);
    var quantity=selectedQuantity(productRoot);
    if(!/^\d+$/.test(String(variantId)))return'';
    return new URL(rootUrl()+'cart/'+encodeURIComponent(String(variantId))+':'+quantity,window.location.origin).toString();
  }
  function syncBuyNow(productRoot){
    if(!productRoot)return;
    var button=productRoot.querySelector('[data-veyrissa-buy-now]');
    if(!button)return;
    var available=productRoot.getAttribute('data-current-available')==='true';
    button.disabled=!available;
    button.setAttribute('aria-disabled',available?'false':'true');
  }
  function init(scope){
    var root=scope&&scope.querySelectorAll?scope:document;
    root.querySelectorAll('[data-product-root]').forEach(syncBuyNow);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target||document);});
  document.addEventListener('change',function(event){
    var productRoot=event.target&&event.target.closest?event.target.closest('[data-product-root]'):null;
    if(productRoot)window.requestAnimationFrame(function(){syncBuyNow(productRoot);});
  },true);

  document.addEventListener('click',function(event){
    var buyNow=event.target&&event.target.closest?event.target.closest('[data-veyrissa-buy-now]'):null;
    if(buyNow){
      event.preventDefault();event.stopImmediatePropagation();
      if(buyNow.disabled||buyNow.getAttribute('aria-disabled')==='true')return;
      var productRoot=buyNow.closest('[data-product-root]');
      var url=directBuyUrl(productRoot);
      if(url)openDestination(url,buyNow);
      return;
    }
    var checkout=event.target&&event.target.closest?event.target.closest('.cart-summary__checkout, button[name="checkout"]'):null;
    if(!checkout)return;
    event.preventDefault();event.stopImmediatePropagation();openDestination(checkoutUrl(),checkout);
  },true);

  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!form||!form.matches)return;
    var submitter=event.submitter;
    var isCheckoutForm=form.matches('.cart-summary__checkout-form');
    var isCheckoutSubmit=submitter&&submitter.matches&&submitter.matches('button[name="checkout"], .cart-summary__checkout');
    if(!isCheckoutForm&&!isCheckoutSubmit)return;
    event.preventDefault();event.stopImmediatePropagation();openDestination(checkoutUrl(),submitter);
  },true);
})();